<div class="position-fixed z-index-12 bg-white w-100 h-100 start-0 top-0 text-center overflow-auto pt-header-space">
  <div class="d-flex flex-column align-items-center justify-content-center h-100 pb-6">
    <div class="mb-8">
      <h1 class="fs-2hx mb-8">พักเรียนชั่วคราว</h1>
      <section class="fs-3 fw-light">
        <div class="">
          ขณะนี้ระบบได้หยุดการนับเวลาเรียนของคุณไว้ชั่วคราว
          เวลาเรียนของคุณจะไม่สูญหาย
        </div>
        <div class="">
          หากต้องการเริ่มเรียนต่อกรุณากดปุ่ม
          <span class="text-primary fw-semibold">เริ่มเรียนต่อ</span>
          ที่ด้านล่าง
        </div>
        <div class="">
          หรือ
          <span class="text-secondary fw-semibold">กลับสู่แดชบอร์ด</span>
          เพื่อเลือกเรียนคอร์สอื่นๆ
        </div>
      </section>
    </div>
    <div class="d-flex flex-row gap-4">
      <button class="btn btn-primary" (click)="onResume()">
        <div class="d-flex flex-row align-items-center">
          <app-keenicon name="to-right" class="fs-2 me-1 svg svg-icon"></app-keenicon>
          เริ่มเรียนต่อ
        </div>
      </button>
      <button class="btn btn-secondary bg-gray-200i" (click)="onBack()">
        กลับสู่แดชบอร์ด
      </button>
    </div>
  </div>
</div>